var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-cascader',{style:({
      width: _vm.catewidth + 'px',
    }),attrs:{"options":_vm.categoryList,"props":_vm.props,"collapse-tags":"","clearable":""},on:{"change":function($event){return _vm.inputChange($event)}},model:{value:(_vm.selectedData),callback:function ($$v) {_vm.selectedData=$$v},expression:"selectedData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }